<div class="modal-header">
    <div class="modal-title">How Forecasting works</div>
    <button id="how-forecasting-works-close" type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body font-size-20">
    <p>To edit the forecast, enter your financials for the interim period and they will automatically be annualized. Or, manually
        input projections into the forecast column directly.</p>

    <p>You can also use buttons on the left side of each column to adjust the forecast amount.</p>

    <p>The A button annualizes your interim value.<br />
        The LY button uses the last year's amount.<br />
        The L% button uses the prior year’s percentage of sales and applies it to the revenue (sales margin).<br />
        The H% button uses the historical average percentage of sales and applies it to the revenue.</p>

    <p>To have our system calculate projections automatically from your interim revenues click "Calculate
        automatically".</p>
</div>
